const VueFileUploader = {
    install: function (Vue) {
        const fileuploader = window['$fileuploader'];

        Vue.prototype.$fileuploader = fileuploader
    }
}

export default VueFileUploader
